import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CopyUtil } from 'src/app/common/util';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { TokenAlphaService } from 'src/app/services/token-alpha.service';

@Component({
  selector: 'app-token-alpha',
  templateUrl: './token-alpha.component.html',
  styleUrls: ['./token-alpha.component.scss']
})
export class TokenAlphaComponent {
  buttonGenerate = new ButtonLoading("btn-success", false, "GENERAR", "fa-hammer");
  loading = false;
  token = null;

  constructor(
    private tokenService: TokenAlphaService,
    private toastService: ToastrService
  ) {

  }

  generate() {
    if (this.loading) {
      return;
    }
    this.loading = true;
    this.tokenService.createToken().subscribe({
      next: (response: ResponseObject) => {
        this.token = response.data;
        setTimeout(() => {
          this.loading = false;
        }, 300);
      },
      error: (error) => {
        setTimeout(() => {
          this.loading = false;
        }, 300);
        this.toastService.error("Error al crear el token");
      }
    })
  }

  copy() {
    CopyUtil.copy(this.token);
    this.toastService.info("Copiado al portapapeles!");
  }

}
